/// <amd-module name="ExtensionManagement/ManagementHub/ExtensionsMasterDetailView" />
import * as React from "react";

import { ObservableValue } from "VSS/Core/Observable";

import { IVssPageContext } from "VSS/Platform/Context";

import { DetailsPanel, MasterPanel, MasterPanelHeader } from "VSSUI/MasterDetails";
import { BaseMasterDetailsContext, IMasterDetailsContext, IMasterDetailsContextLayer, MasterDetailsContext } from "VSSUI/MasterDetailsContext";

import { ExtensionDetailPanelContent } from "./ExtensionDetailPanel";
import { ExtensionsMasterPanelContent } from "./ExtensionsMasterPanel";
import { IExtensionsService } from "./ExtensionsService";
import { TabType, IExtensionViewModel } from "./UIContracts";

import * as Resources from "ExtensionManagement/ManagementHub/Resources.ExtManagmentHub";

interface IExtensionsMasterDetailViewProps {
    /**
     * List of extensions to be displayed in master panel
     */
    extensions: IExtensionViewModel[];

    /**
     * Reference to extension service
     */
    extensionsService: IExtensionsService;

    /**
     * Initially selected extension
     */
    initialSelection: IExtensionViewModel;

    /**
     * Context for Persona provider.
     */
    pageContext: IVssPageContext;

    /**
     * Page state history observable to update on selection
     */
    selectedExtensionIdentifier: ObservableValue<string>;

    /**
     * Selected tab's Id
     */
    selectedTabId: string;

    /**
     * Delegate to switch to main view
     */
    switchToMainView: () => void;
}

export class ExtensionsMasterDetailView extends React.Component<IExtensionsMasterDetailViewProps> {
    private initialPayload: IMasterDetailsContextLayer<IExtensionViewModel>;
    private masterDetailsContext: IMasterDetailsContext;
    private title: string;

    constructor(props: IExtensionsMasterDetailViewProps) {
        super(props);

        if (props.selectedTabId === TabType.requested) {
            this.title = Resources.RequestedExtensions;
        } else if (props.selectedTabId === TabType.shared) {
            this.title = Resources.SharedExtensions;
        } else {
            this.title = Resources.InstalledExtensions;
        }

        this.initialPayload = {
            key: "initial",
            masterPanelContent: {
                renderContent: (parentItem, selectedItem) => (
                    <ExtensionsMasterPanelContent
                        extensionList={this.props.extensions}
                        listAriaLabel={this.title}
                        selectedExtension={selectedItem}
                        selectedTabId={this.props.selectedTabId}
                    />
                ),
                renderHeader: () => <MasterPanelHeader title={this.title} titleAriaLevel={2} />
            },
            detailsContent: {
                renderContent: (item) => (
                    <ExtensionDetailPanelContent
                        extensionsService={this.props.extensionsService}
                        pageContext={this.props.pageContext}
                        selectedExtension={item}
                        selectedExtensionIdentifier={this.props.selectedExtensionIdentifier}
                        selectedTabId={this.props.selectedTabId}
                        switchToMainView={this.props.switchToMainView}
                    />
                )
            },
            selectedMasterItem: new ObservableValue<IExtensionViewModel>(this.props.initialSelection),
            parentItem: undefined
        };

        this.masterDetailsContext = new BaseMasterDetailsContext(this.initialPayload, this.props.switchToMainView);
    }

    public render(): JSX.Element {
        return (
            <MasterDetailsContext.Provider value={this.masterDetailsContext}>
                <div className="flex-row flex-grow v-scroll-auto">
                    <MasterPanel />
                    <DetailsPanel />
                </div>
            </MasterDetailsContext.Provider>
        );
    }
}
